/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetConfig200ResponsePrintersInner
 */
export interface GetConfig200ResponsePrintersInner {
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponsePrintersInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponsePrintersInner
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponsePrintersInner
     */
    ip?: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponsePrintersInner
     */
    type: GetConfig200ResponsePrintersInnerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponsePrintersInner
     */
    model?: string;
    /**
     * 
     * @type {any}
     * @memberof GetConfig200ResponsePrintersInner
     */
    metadata?: any | null;
    /**
     * 
     * @type {number}
     * @memberof GetConfig200ResponsePrintersInner
     */
    ticketWidth?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetConfig200ResponsePrintersInner
     */
    ticketHeight?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetConfig200ResponsePrintersInner
     */
    ticketPaddingLeft?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200ResponsePrintersInner
     */
    tillEnabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponsePrintersInner
     */
    tillId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200ResponsePrintersInner
     */
    splitProducts: boolean;
}


/**
 * @export
 */
export const GetConfig200ResponsePrintersInnerTypeEnum = {
    StarGraphic: 'StarGraphic',
    StarPrnt: 'StarPRNT',
    EscPos: 'EscPos',
    AdyenPrinter: 'AdyenPrinter',
    EscPosMatrix: 'EscPosMatrix',
    Zpl: 'ZPL',
    Usb: 'Usb',
    Kds: 'KDS',
    UsbAndroid: 'UsbAndroid',
    Browser: 'browser'
} as const;
export type GetConfig200ResponsePrintersInnerTypeEnum = typeof GetConfig200ResponsePrintersInnerTypeEnum[keyof typeof GetConfig200ResponsePrintersInnerTypeEnum];


/**
 * Check if a given object implements the GetConfig200ResponsePrintersInner interface.
 */
export function instanceOfGetConfig200ResponsePrintersInner(value: object): value is GetConfig200ResponsePrintersInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('tillEnabled' in value) || value['tillEnabled'] === undefined) return false;
    if (!('splitProducts' in value) || value['splitProducts'] === undefined) return false;
    return true;
}

export function GetConfig200ResponsePrintersInnerFromJSON(json: any): GetConfig200ResponsePrintersInner {
    return GetConfig200ResponsePrintersInnerFromJSONTyped(json, false);
}

export function GetConfig200ResponsePrintersInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetConfig200ResponsePrintersInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'ip': json['ip'] == null ? undefined : json['ip'],
        'type': json['type'],
        'model': json['model'] == null ? undefined : json['model'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
        'ticketWidth': json['ticketWidth'] == null ? undefined : json['ticketWidth'],
        'ticketHeight': json['ticketHeight'] == null ? undefined : json['ticketHeight'],
        'ticketPaddingLeft': json['ticketPaddingLeft'] == null ? undefined : json['ticketPaddingLeft'],
        'tillEnabled': json['tillEnabled'],
        'tillId': json['tillId'] == null ? undefined : json['tillId'],
        'splitProducts': json['splitProducts'],
    };
}

export function GetConfig200ResponsePrintersInnerToJSON(json: any): GetConfig200ResponsePrintersInner {
    return GetConfig200ResponsePrintersInnerToJSONTyped(json, false);
}

export function GetConfig200ResponsePrintersInnerToJSONTyped(value?: GetConfig200ResponsePrintersInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'ip': value['ip'],
        'type': value['type'],
        'model': value['model'],
        'metadata': value['metadata'],
        'ticketWidth': value['ticketWidth'],
        'ticketHeight': value['ticketHeight'],
        'ticketPaddingLeft': value['ticketPaddingLeft'],
        'tillEnabled': value['tillEnabled'],
        'tillId': value['tillId'],
        'splitProducts': value['splitProducts'],
    };
}

